import { memo } from "react";

const ProjectTypes = memo(({
  project_types,
}) => (
  <ul className="project-types">
    {project_types.map(project_type => (
      <li key={project_type.id}>{project_type.name}</li>
    ))}
  </ul>
));

export default ProjectTypes;
